import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * reject appointment superbill
 */
export default async function rejectSuperbill(statement_no: string | number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/superbill/appointment/reject/${statement_no}`,
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }
}
